import { z } from 'zod';

export const environmentKeySchema = z.object({
  environmentKey: z.string().trim().min(1, 'Paste the environment key.'),
});

export type EnvironmentKeyValues = z.infer<typeof environmentKeySchema>;

export const ENVIRONMENT_KEY_DEFAULTS: EnvironmentKeyValues = { environmentKey: '' };
